import { Link } from "react-router-dom";
import BrandLogo from "@/components/BrandLogo";
import { Mail, Phone } from "lucide-react";

export default function MarketingFooter() {
  return (
    <footer className="bg-ink text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2">
          <Link to="/" className="inline-flex items-center">
            <BrandLogo size="md" variant="onDark" />
          </Link>
          <p className="text-sm text-white/60 mt-3 leading-relaxed max-w-xs">
            One in-house platform powering multi-vendor dining across corporate campuses, malls, universities, schools, and expressways.
          </p>
        </div>
        <div>
          <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-sun mb-3">Verticals</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/corporate" className="hover:text-white">Corporate</Link></li>
            <li><Link to="/malls" className="hover:text-white">Malls &amp; Food Courts</Link></li>
            <li><Link to="/education" className="hover:text-white">Colleges &amp; Universities</Link></li>
            <li><Link to="/schools" className="hover:text-white">K-12 Schools</Link></li>
            <li><Link to="/expressways" className="hover:text-white">Expressways</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-sun mb-3">Product</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/#capabilities" className="hover:text-white">Platform</Link></li>
            <li><Link to="/#stack" className="hover:text-white">Tech stack</Link></li>
            <li><Link to="/#numbers" className="hover:text-white">By the numbers</Link></li>
            <li><Link to="/#verticals" className="hover:text-white">Who we serve</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-sun mb-3">Contact</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><a href="mailto:hello@grubpe.com" className="hover:text-white inline-flex items-center gap-2"><Mail size={13}/> hello@grubpe.com</a></li>
            <li><a href="tel:+919100142112" className="hover:text-white inline-flex items-center gap-2"><Phone size={13}/> +91 91001 42112</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 text-[11px] text-white/40 flex items-center justify-between flex-wrap gap-2">
          <span>© {new Date().getFullYear()} Grubpe Technologies. All rights reserved.</span>
          <span>Made in India · Cloud-native · 99.9% uptime</span>
        </div>
      </div>
    </footer>
  );
}
